import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ChatMessage } from '../../../models/chat-message';
import { EnumType } from '../../../models/enums/enum';

@Component({
	selector: 'app-chat-message-button-intent',
	templateUrl: './chat-message-button-intent.component.html',
	styleUrls: ['./chat-message-button-intent.component.scss']
})
export class ChatMessageButtonIntentComponent implements OnInit {

	@Input() index: number;
	@Input() elements: any;
	@Output() onOptionMessageClicked: EventEmitter<any> = new EventEmitter<any>();

	constructor() { }

	ngOnInit() { }

	addMessage(item: any) {

		if (item.type == "web_url") {
			let url: string = '';
			if (!/^http[s]?:\/\//.test(item.intent)) {
				url += 'http://';
			}
			url += item.intent
			window.open(url, "_blank");
		} else {
			let element: ChatMessage = {
				senderName: EnumType.MessageSender.USER,
				time: new Date(),
				payload: {
					type: 'text',
					values: item.text,
					intent: item.intent
				}
			};
			this.onOptionMessageClicked.emit(element);
		}

	}
}
